import { useEffect, useState } from "react";
import api from "@/lib/api";

// Polls the tenant-scoped live-call count for the sidebar/dashboard badge.
export function useLiveCallsCount(intervalMs = 8000) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/live-calls/count");
        if (alive) setCount(data.count || 0);
      } catch {
        /* transient — keep last value */
      }
    };
    load();
    const t = setInterval(load, intervalMs);
    return () => { alive = false; clearInterval(t); };
  }, [intervalMs]);
  return count;
}
